import React from 'react'
import Button from "../../../../Button"
import "../../Home.css"
import Mcity1 from "../../../../../images/magiccity1.jpg";
import Mcity2 from "../../../../../images/magiccity2.jpeg";

function index() {
    return (
            <div className="home_top">
        <div className="home_left">
          <div className="home_left_inner">
            <p className="year">2021</p>
            <h2>
              Magic <br /> City
            </h2>
            <p className="text">
              New Park of Tashkent city, build in 2021, June. Welcomes thousands
              of visitors every month. Come and enjoy this art of Uzbekistan!
            </p>
            <div className="home_left_btn">
              <a href="a">
                <Button title="watch now " />
              </a>
            </div>
          </div>
        </div>
        <div className="home_right">
          <div className="home_right_content">
            <div className="hrc_text txt1">
              <p>
                <span>Every Tueasday and Sunday</span>
                <div>Fountain Dance</div>
                <span>
                  In the new Magic city park, there will held Fountain Dance
                  show in every Tuesday and Sunday. Most of the people come here
                  to watch and enjoy from this show!
                </span>
              </p>
            </div>
            <div className="hrc_img">
              <img src={Mcity1} alt="" />
            </div>
          </div>
          <div className="home_right_content">
            <div className="hrc_img">
              <img src={Mcity2} alt="" />
            </div>
            <div className="hrc_text txt2">
              <p>
                <span>August, 2021</span>
                <div>Everyday Tours</div>
                <span>
                  In the new Magic city park, there will held Fountain Dance
                  show in every Tuesday and Sunday. Most of the people come here
                  to watch and enjoy from this show!
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    )
}

export default index
